export default __webpack_public_path__ + "static/media/AtlasShrugged.2149f22e.png";